import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function SuccessPage() {
  const { t } = useTranslation();
  const location = useLocation();
  const { type, message } = location.state || {};

  const getContent = () => {
    switch (type) {
      case 'registration':
        return {
          title: t('success.registration.title'),
          message: message || t('success.registration.message'),
          icon: 'check',
          actions: [{ label: t('success.registration.action'), to: '/v4', primary: true }],
        };
      case 'password-reset':
        return {
          title: t('success.passwordReset.title'),
          message: t('success.passwordReset.message'),
          icon: 'check',
          actions: [{ label: t('success.passwordReset.action'), to: '/login', primary: true }],
        };
      case 'email-verified':
        return {
          title: t('success.emailVerified.title'),
          message: t('success.emailVerified.message'),
          icon: 'email',
          actions: [{ label: t('success.emailVerified.action'), to: '/v4', primary: true }],
        };
      case 'subscription':
        return {
          title: t('success.subscription.title'),
          message: t('success.subscription.message'),
          icon: 'star',
          actions: [{ label: t('success.subscription.action'), to: '/v4', primary: true }],
        };
      default:
        return {
          title: t('success.default.title'),
          message: message || t('success.default.message'),
          icon: 'check',
          actions: [{ label: t('success.default.action'), to: '/v4', primary: true }],
        };
    }
  };

  const content = getContent();

  const renderIcon = () => {
    switch (content.icon) {
      case 'check':
        return (
          <svg viewBox="0 0 24 24">
            <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" fill="currentColor" />
          </svg>
        );
      case 'email':
        return (
          <svg viewBox="0 0 24 24">
            <path
              d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"
              fill="currentColor"
            />
          </svg>
        );
      case 'star':
        return (
          <svg viewBox="0 0 24 24">
            <path
              d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"
              fill="currentColor"
            />
          </svg>
        );
      default:
        return null;
    }
  };

  return (
    <div className="success-container">
      <div className="success-card">
        <div className="success-icon">{renderIcon()}</div>
        <h1 className="success-title">{content.title}</h1>
        <p className="success-message">{content.message}</p>
        <div className="success-actions">
          {content.actions.map((action, index) => (
            <Link
              key={index}
              to={action.to}
              className={`btn ${action.primary ? 'btn-primary' : 'btn-secondary'}`}
            >
              {action.label}
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
